import { ParagraphProps } from '../../../components/PageBuilder/Paragraph/Paragraph';
import HormoneReplacement from '../../../assets/images/unique/HormoneReplacement/hormone_replacement.jpg';

export const HormoneReplacementParagraphs: ParagraphProps[] = [
  {
    title: 'What it consists of',
    text: `Hormonal health is the study of how chemical signals affect energy, sleep, temperature regulation, mood, libido, metabolism, concentration, and tissue health. A consultation usually begins by connecting symptoms with age, reproductive stage, thyroid function, stress, nutrition, medications, and medical history.`,
    img: HormoneReplacement,
  },
  {
    title: 'What it may help clarify',
    text: `This topic may be relevant when exploring hot flashes, sleep disruption, fatigue, brain fog, mood changes, weight changes, low libido, irregular cycles, or symptoms around menopause or andropause. The purpose is not to assume one cause, but to understand which systems may be involved.`,
  },
  {
    title: 'What is reviewed before deciding',
    text: `A careful review may include symptoms, family history, previous surgeries, medications, menstrual or menopause history when relevant, metabolic health, thyroid markers, and appropriate lab interpretation. Risk, benefit, timing, and monitoring all matter before discussing any clinical strategy.`,
  },
  {
    title: 'What to keep in mind',
    text: `No single hormonal approach fits everyone. Some people may need lifestyle support, further testing, closer monitoring, or a different medical explanation for their symptoms. A private consultation helps translate symptoms and labs into a plan that respects goals, context, and safety profile.`,
  },
];
